import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import {
  BatchSpanProcessor,
  ReadableSpan,
  SimpleSpanProcessor,
  TracerConfig,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { AuthTokenEmitter } from '.';
import { OTLPExporterNodeConfigBase } from '@opentelemetry/otlp-exporter-base';
import { ExportResult } from '@opentelemetry/core';

class CustomOTLPTraceExporter extends OTLPTraceExporter {
  private _headers: Record<string, unknown> = {};
  private token: string | undefined;

  constructor(config: OTLPExporterNodeConfigBase) {
    super(config);
    this._headers = { ...config.headers };

    AuthTokenEmitter.on('token', (newToken: string) => {
      this.token = newToken;
      this._headers = { ...this._headers, Authorization: `Bearer ${newToken}` };
    });
  }

  export(items: ReadableSpan[], resultCallback: (result: ExportResult) => void) {
    if (this.token) {
      this._headers = { ...this._headers, Authorization: `Bearer ${this.token}` };
    }

    return super.export(items, resultCallback);
  }
}

export const StartOTEL = (token: string) => {
  const exporter = new CustomOTLPTraceExporter({
    url: window.location.origin + '/v1/traces',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });

  const processor = new BatchSpanProcessor(exporter);
  const resource = resourceFromAttributes({
    'service.name': 'eui-web-client',
  });

  const providerConfig: TracerConfig = {
    resource: resource,
    spanProcessors: [processor],
  };

  const provider = new WebTracerProvider(providerConfig);

  provider.register({
    contextManager: new ZoneContextManager(),
  });
};

export const StartAutoInstrumentation = () => {
  registerInstrumentations({
    instrumentations: [
      // getWebAutoInstrumentations initializes all the package.
      // it's possible to configure each instrumentation if needed.
      getWebAutoInstrumentations(),
    ],
  });
};

// Function for getting OTEL attributes from the URL for each request
export const generateOTELAttrs = (url?: string) => {
  let title = 'send-request-';
  let crumbs = url?.split(/\//g)?.slice(1) ?? []; //Split url by "/" and remove the first empty element
  let windowID: string | undefined;
  let rssURL: string | undefined;
  let exportType: string | undefined;
  if (crumbs?.[0] === 'window') {
    switch (crumbs.length) {
      case 3: // /window/:window/interact
        windowID = crumbs.splice(1, 1)[0];
        break;
      case 4: // /window/:window/load/context
        windowID = crumbs.splice(1, 1)[0];
        break;
      case 5: // /window/:session/:window/export/:type
        crumbs.splice(1, 1);
        windowID = crumbs.splice(2, 1)[0];
        exportType = crumbs.splice(4, 1)[0];
        break;
      case 1:
      default:
        break;
    }
  }
  if (crumbs?.[1] === 'rss-proxy') {
    // /client/rss-proxy/:url
    rssURL = crumbs.pop();
  }
  title += crumbs.join('-');
  return { title, windowID, rssURL, exportType };
};
